export const URL = process.env.VUE_APP_API

export const api_pcap = URL